<template>
  <gc-main-layout :title="title" :isXSmall="isXSmall" :isLarge="isLarge">
    <div>
      <h2 class="content-block">Page Not Found</h2>
      <div class="content-block">
        <div class="view-card responsive-paddings">
          <router-link to="/home">Back to Home</router-link>
        </div>
      </div>
    </div>
  </gc-main-layout>
</template>
<script>
import BaseViewMixin from "../v1/_mixins/base.view";

export default {
  mixins: [BaseViewMixin]
};
</script>